import 'hover.css';
import 'animate.css';
import './css/w3pro.css';
import './less/index.less';
import {getSession, setSession, openURL} from "./js/util.js";
window.addEventListener('contextmenu', event => event.preventDefault());

$.fn.extend({
  animateCss: function (animationName, callback) {
    var animationEnd = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
    this.addClass("animate__animated animate__" + animationName).one(animationEnd, function () {
      $(this).removeClass("animate__animated animate__" + animationName);
      if (callback) callback();
    });
    return this;
  },
  bounce: function (_defaultTop, callback) {
    let defaultTop = _defaultTop || 0;
    var interval = 100;
    var distance = 20;
    var times = 6;
    var damping = 0.8;

    for (var i = 0; i < (times + 1); i++) {
      var amt = Math.pow(-1, i) * distance / (i * damping);
      $(this).animate({
        top: amt
      }, interval);
    }
    $(this).animate({
      top: 0
    }, interval, '', () => {
      if (defaultTop != 0) {
        $(this).css('top', defaultTop);
      }
      if (typeof callback == 'function') callback()
    });
  }
});

let carousel = false;
class CardCarousel {
  constructor(container) {
    // DOM elements
    this.container = container;
    this.cards = container.querySelectorAll(".card");

    // Data
    this.centerIndex = Math.floor(this.cards.length / 2);
    this.xScale = {};
    this.readyDrag = false;
    this.timer = null;
    this.xDist = 0;

    // Initializers
    this.build();

    // Get the distance that the user has dragged
    this.getDistance(this.moveCards.bind(this));
  }
  preUpdateCard() {
    let defaultWidth = 339;
    let defaultHeight = 461;
    this.cardHeight = parseInt(this.container.offsetHeight) * 0.85;
    this.cardWidth = defaultWidth * (this.cardHeight / defaultHeight);
  }
  build() {
    this.preUpdateCard();
    for (var i = 0; i < this.cards.length; i++) {
      let prop = {};
      prop.x = i - this.centerIndex;
      prop.zIndex = -(Math.abs(i - this.centerIndex));
      prop.scale = this.calcScale(prop.x);
      prop.leftPos = this.calcPos(prop.x, prop.scale);
      this.xScale[prop.x] = this.cards[i];
      this.updateCards(this.cards[i], prop);
      $(this.cards[i]).children('.name-tag').attr('class', `name-tag name-tag-${prop.x <= 0 ? 'left' : 'right'}`);
      if (i == this.cards.length - 1) {
        let centerCardValue = String(this.centerIndex + 1).padStart(2, 0);
        let centerCard = '.card[data-value=' + centerCardValue + ']';
        $('.card:not([data-value=' + centerCardValue + '])').addClass('hide');
        let centerCardTop = $(centerCard).css('top');
        $(centerCard).bounce(centerCardTop, () => {
          this.setCardEvent(centerCard);
        });
      }
    }
  }
  updateArrowPosition() {
    let arrowLeft = $('#arrow-div .arrow_left');
    let arrowRight = $('#arrow-div .arrow_right');
    let centerCard = $('.card[data-x=0]');
    let centerCardLeft = parseInt(centerCard.css('left'));
    arrowRight.css({ 'left': centerCardLeft + parseInt(centerCard.css('width')) + 'px' });
    arrowLeft.css({ 'left': centerCardLeft - parseInt(arrowLeft.css('width')) + 'px' });
  }
  setCardEvent(centerCard) {
    let centerCardLeft = parseInt($(centerCard).css('left'));
    let finalCardIndex = $('.card').length - 1;
    $('.card').each((index, item) => {
      let card = $(item);
      let cardValue = String(index + 1).padStart(2, 0);
      let oldCardLeft = parseInt(card.css("left"));
      let thisCardLeft = centerCardLeft - oldCardLeft;
      card.removeClass('hide').css("left", centerCardLeft + 'px');
      card.animate({ "left": "-=" + thisCardLeft + 'px' }, 'slow', '', () => {
        card.css("left", oldCardLeft);
        let img = card.children('.card-main-img');
        let imgPrefix = `./img/char${cardValue}`;
        $(img).attr('onerror', 'this.onerror=null;this.src=\'' + imgPrefix + '.png\';"');
        img.on('mousemove', event => {
          var dataX = $(event.target).closest('.card').attr('data-x');
          if (dataX != '0') {
            return;
          }
          $(event.target).attr('src', imgPrefix + '_o.png');
        });
        img.on('mouseout', event => {
          var img_src = imgPrefix + '.png';
          var is_en = $(".navbar-title>img").attr('src');
          if (is_en.toLowerCase().indexOf("_eng") >= 0 && $(event.target).hasClass('card-main-img') == false) {
            img_src = (img_src).replace(".png", "_eng.png");
          }
          $(event.target).attr('src', img_src);
        });
      });
      if (index == finalCardIndex) {
        $('#arrow-div').removeClass('hide');
        $('.bg-toplight').removeClass('hide').css({ height: '0%' }).animate({ height: '100%' });
        $('.card>.card-main-img').addClass('reflect');
        $('#card-carousel .card .view-count').removeClass('hide');
        // $('.card>.hd-tag').addClass('reflect');
        $('.card>img').on('click tap', event => {
          let clickedCard = $(event.target).closest('.card');
          let clickedCardDataX = parseInt(clickedCard.attr('data-x'));
          if (clickedCardDataX != 0) {
            console.log('return by none-center-card', clickedCardDataX);
            this.cardsAnimateEaseOut(clickedCardDataX*-1, 500);
            closeSubtitleOption();
            return;
          }
          if ($('#arrow-div>img').hasClass('animate__flash')) {
            console.log('return by carousel moving');
            return;
          }
          var videoID = clickedCard.attr('data-value') || false;
          var videoLang = 'can';
          var videoRes = $(event.target).hasClass('hd-tag') ? 'hd' : "sd";
          if($('.lang-icon').length!=0){
            videoLang = $('.lang-icon.active').attr('name').replace('lang_', '');
          }         
          if(videoLang=='eng') videoLang='can';
          let videoPath = 'video/eduhk_le_animate_a' + videoID + '_';
          if(videoLang=='pth'){
            let subtitleOption = $(event.target).closest('.card').find('.subtitleOption');
            this.readyDrag = false;
            openSubtitleOption(subtitleOption, videoPath, videoRes);
          }else{
            videoPath += videoLang + '_' + videoRes + '.mp4';
            openURL('https://crse.eduhk.mers.hk/player.php', '_blank', { 'file': videoPath }, 'GET');
          } 
        });
        this.updateAllCardBrightness();
        this.updateArrowPosition();
      }
    });
  }
  updateCardBrightness(card, dataX) {
    let brightness = (dataX == 0) ? 100 : 1 / (Math.abs(dataX) + 0.6) * 100 + 25;
    $(card).css({ "-webkit-filter": "brightness(" + brightness + "%)" });
    $(card).children('.name-tag').attr('class', `name-tag name-tag-${dataX <= 0 ? 'left' : 'right'}`);
  }
  updateAllCardBrightness() {
    console.log('trigger updateAllCardBrightness');
    let count_xScale = 0;
    let total_xScale = Object.keys(this.xScale).length;
    for (var x in this.xScale) {
      this.updateCardBrightness(this.xScale[x], x);
      this.updateCards(this.xScale[x], {
        x: x,
        zIndex: Math.abs(Math.abs(x) - this.centerIndex)
      });
      if(++count_xScale==total_xScale){
        this.readyDrag = true;
      }
    }
  }
  checkOrdering(card, xDist) {
    var x = parseInt(card.dataset.x);
    var newX = x;
    var rounded = Math.round(xDist);
    let t = (this.cards.length % 2 == 0) ? 0 : 1;
    let c1 = ((x + rounded - t) - this.centerIndex) - rounded + -this.centerIndex;
    let c2 = ((x + rounded + t) + this.centerIndex) - rounded + this.centerIndex;
    let c3 = newX - this.centerIndex - t - this.centerIndex;
    let c4 = this.centerIndex - (Math.abs(newX + this.centerIndex) - t);
    if (rounded > 0) {
      if (x + rounded > this.centerIndex) {
        newX = c1;
      } else if (x + rounded < -this.centerIndex) {
        newX = c2
      }
    } else if (rounded < 0) {
      if (x + rounded < -this.centerIndex) {
        newX = c2
      } else if (x + rounded > this.centerIndex) {
        newX = c1;
      }
    } else {
      if (newX > this.centerIndex) {
        newX = c3;
      } else if (newX < -this.centerIndex) {
        newX = c4;
      }
    }
    let newXRounded = newX + rounded;
    this.xScale[newXRounded] = card;
    this.updateCardBrightness(card, newXRounded);
    return {
      x: newX,
      zIndex: -Math.abs(newXRounded)
    };
  }
  event(callback) {
    var handler;
    const that = this;
    this.container.addEventListener("mousedown", (e) => {
      e.preventDefault();
      if (this.readyDrag == false) return;
      handler = callback(e);

      window.addEventListener("mousemove", handler);
      window.addEventListener("mouseup", clearDraggingEvent);
      window.addEventListener("mouseleave", clearDraggingEvent);
      function clearDraggingEvent() {
        window.removeEventListener("mousemove", handler);
        window.removeEventListener("mouseup", clearDraggingEvent);
        window.removeEventListener("mouseleave", clearDraggingEvent);
        handler(null);
        that.slideCard();
      }
    });
  
    this.container.addEventListener("touchstart", (e) => {
      if (this.readyDrag == false) return;
      handler = callback(e);

      window.addEventListener("touchmove", handler);
      window.addEventListener("touchend", clearDraggingEvent);
      function clearDraggingEvent() {
        window.removeEventListener("touchmove", handler);
        window.removeEventListener("touchend", clearDraggingEvent);
        handler(null);
        that.slideCard();
      }
    }, { passive: true });
  }
  slideCard() {    
    const that = this;
    if (that.startTime) {
      if (new Date().getTime() - that.startTime < 500 && that.xDist != 0) {
        const flagNum = (that.centerIndex * 2 + 2) - 3;
        that.xDist = that.xDist > flagNum ? flagNum : that.xDist < -flagNum ? -flagNum : that.xDist;
        that.cardsAnimateEaseOut(that.xDist, 1000, 3);
      } else {
        that.resetArrowAnimation();
      }
    }
    that.xDist = 0;
    that.updateAllCardBrightness();
  }
  calcScale(x) {
    let direction = (x <= 0) ? -1 : 1;
    let scale = 1 - (direction / this.cards.length * x);
    return scale;
  }
  calcPos(x, scale) {
    let cardWidthPercent = this.cardWidth / this.container.offsetWidth * 100;
    let pos = 50 - cardWidthPercent / 2;
    if (x != 0) {
      pos = pos + (scale * cardWidthPercent) * x + x * 2 + (1 - scale) * cardWidthPercent / 2;
    }
    return pos;
  }
  //arg: 位置，時間，多移minPosition
  cardsAnimateEaseOut(moveNum, duration, minPosition = 0) {
    const targetNum = Math.round(moveNum) + (moveNum > 0 ? minPosition : -minPosition);
    var a = 2 * targetNum / (duration * duration); //加速度
    var v0 = Math.sqrt(targetNum * 2 * a); //初速度
    v0 = targetNum > 0 ? v0 : -v0;
    let timeNum = 0;
    if (this.timer != null) clearInterval(this.timer);
    this.timer = setInterval(() => {
      let movingSpeed = v0 - a * timeNum;
      if (targetNum != 0 && movingSpeed != 0) {
        timeNum += 10;
        const num = v0 * timeNum - (a * timeNum * timeNum) / 2;
        this.changeCardsAttr(num);
      } else {
        console.log('clearInterval');
        clearInterval(this.timer);
        this.resetArrowAnimation();
        this.updateAllCardBrightness();
      }
    }, 10);
  }
  resetArrowAnimation() {
    $('#arrow-div>img').removeClass('hide animate__flash');
    $('#arrow-div>.arrow_left').addClass('animate__fadeOutLeft');
    $('#arrow-div>.arrow_right').addClass('animate__fadeOutRight');
  }
  getDistance(callback) {
    var that = this;

    function distanceInit(e1) {
      var startingX, startingY;
      that.startTime = new Date().getTime();

      if ("touches" in e1) {
        startingX = e1.touches[0].clientX;
        startingY = e1.touches[0].clientY;
      } else {
        startingX = e1.clientX;
        startingY = e1.clientY;
      }

      return function (e2) {
        if (e2 === null) {
          return callback(null)
        } else {
          if ("touches" in e2) {
            return callback({
              x: e2.touches[0].clientX - startingX,
              y: e2.touches[0].clientY - startingY,
            })
          } else {
            return callback({
              x: e2.clientX - startingX,
              y: e2.clientY - startingY
            })
          }
        }
      }
    }

    this.event(distanceInit)
  }
  moveCards(data) {
    // console.log('moveCards', data);
    var xDist = Math.round(this.xDist);

    if (data != null) {
      xDist = data.x / this.cardWidth;
      this.xDist = xDist;
    }
    if (xDist > 0) {
      $('#arrow-div>.arrow_left').addClass('hide').removeClass('animate__fadeOutLeft animated__flash');
      $('#arrow-div>.arrow_right').removeClass('hide animate__fadeOutRight');
      if ($('#arrow-div>.arrow_right').hasClass('animate__flash') == false) {
        $('#arrow-div>.arrow_right').addClass('animate__flash');
      }
    } else if (xDist < 0) {
      $('#arrow-div>.arrow_right').addClass('hide').removeClass('animate__fadeOutRight animated__flash');
      $('#arrow-div>.arrow_left').removeClass('hide animate__fadeOutLeft');
      if ($('#arrow-div>.arrow_left').hasClass('animated__flash') == false) {
        $('#arrow-div>.arrow_left').addClass('animate__flash');
      }
    }

    clearInterval(this.timer);
    this.changeCardsAttr(xDist);
  }
  changeCardsAttr(xDist) {
    this.xScale = {};
    for (var i = 0; i < this.cards.length; i++) {
      let prop = this.checkOrdering(this.cards[i], xDist);
      prop.scale = this.calcScale(prop.x + xDist);
      prop.leftPos = this.calcPos(prop.x + xDist, prop.scale);
      this.updateCards(this.cards[i], prop);
    }
  }
  updateCards(card, data) {
    for (const key in data) {
      switch (key) {
        case 'scale':
          card.style.width = this.cardWidth * data.scale + 'px';
          // card.style.height = this.cardHeight * data.scale + 'px';
          card.style.top = data.scale == 1 ? '0%' : `${(1 - data.scale) / 1.5 * 100}%`;
          break;
        case 'leftPos':
          card.style.left = data.leftPos + "%";
          break;
        case 'zIndex':
          card.style.zIndex = data.zIndex;
          break;
        case 'x':
          card.setAttribute("data-x", data.x);
          $(card).children('.hd-tag').toggleClass('hvr-buzz-out', data.x == 0);
          // $(card).children('.name-tag').attr('class', `name-tag name-tag-${data.x <= 0 ? 'left' : 'right'}`);
          break;
      }
    }
  }
}
function changeLang(_lang, callback) {
  closeSubtitleOption();
  var lang = (_lang == "" || _lang == null) ? 'lang_can' : _lang;
  setSession("language", lang);
  if($(".lang-icon").length!=0){
    $(".lang-icon").removeClass("active");
    $(".lang-icon[name='" + lang + "']").addClass("active");
  }
  $(".navbar-title>img").eq(0).attr('src', './img/title' + (lang == "lang_eng" ? '_eng' : '') + '.png');
  $(".lang-eng").css("display", (lang == "lang_eng" ? 'block' : 'none'));
  $(".lang-chi").css("display", (lang == "lang_eng" ? 'none' : 'block'));
  
  fitContent('changeLang', callback);
}
function fitContent(marker, callback) {
  let nav = $('nav')[0].getBoundingClientRect();
  let title = $('.navbar-title')[0].getBoundingClientRect();
  let titleVerticalMargin = Math.abs(parseInt($('.navbar-title').css('margin-top')) + parseInt($('.navbar-title').css('margin-bottom')));
  let desc = $('.desc')[0].getBoundingClientRect();
  let fileContainer = $('.file-container')[0].getBoundingClientRect();
  let arrowDiv = $('#arrow-div')[0].getBoundingClientRect();
  let footbar = $('.footbar')[0].getBoundingClientRect();
  let fileContainerBottom = 0;
  let baseFileContainerBottom = 20;
  if ($('.file-container').css('position') != 'relative') {//landscape
    fileContainerBottom = footbar.height - baseFileContainerBottom;//-20 for baseFileContainerBottom margin bottom
  }
  // $('.file-container').css('bottom', fileContainerBottom + 'px');
  let carouselHeight = $(window).height() - nav.height - title.height + titleVerticalMargin - desc.height - arrowDiv.height - fileContainer.height + fileContainerBottom - footbar.height + 25;//+20 for pay baseFileContainerBottom margin bottom
  
  $('#card-carousel').css('height', carouselHeight);
  $('.bg-stair-L, .bg-stair-R').css('bottom', footbar.height + 100 + 'px');
  $('.bg-building-L, .bg-building-R').css('bottom', footbar.height + 150 + 'px');
  $('.bg-tree').css('bottom', footbar.height + 100 + $('.bg-building-L').height() - $('.bg-tree').height() / 2 + 'px');
  $('.bg-cloud-L, .bg-cloud-R').css('top', nav.height - 50 + 'px');
  // console.log(marker, 'height:', { html: $(window).height(), nav: nav.height, title: title.height, desc: desc.height, carousel: carouselHeight, fileContainer: fileContainer.height, footbar: footbar.height });
  if (typeof callback === "function") callback();
}
function openSideNav(){
  document.getElementById("sidenav").style.width = "250px";
  $("#sidenav>div").removeClass('hide');
}
function closeSideNav(){
  document.getElementById("sidenav").style.width = "0";
  $("#sidenav>div").addClass('hide');
}
function openModal(tabID='tab-detail'){
  document.getElementById('projectModal').style.display = 'block';
  $('html').addClass('overflow-y-hidden');
  $('.modalMenu>div').removeClass('active');
  $('.modalMenu>div[data-value="'+tabID+'"]').addClass('active');
  $('.modal-tab').removeClass('active');
  $('#'+tabID).addClass('active');
}
function closeModal(){
  document.getElementById('projectModal').style.display = 'none';
  $('html').removeClass('overflow-y-hidden');
  $('.modalMenu>div').removeClass('active');
  $('.modalMenu>div[data-value="tab-home"]').addClass('active');
}
function openSubtitleOption(target, videoPath, videoRes){
  target.removeClass('w3-hide');
  let pthVideo = videoPath + 'pth' + '_' + videoRes + '.mp4';
  let cnVideo = videoPath + 'cn' + '_' + videoRes + '.mp4';
  target.find('.option').eq(0).attr('data-url', pthVideo);
  target.find('.option').eq(1).attr('data-url', cnVideo);
}
function closeSubtitleOption(){
  if(carousel) carousel.readyDrag = true;
  $('.subtitleOption').addClass('w3-hide');
}
function openCompetition2022(){
  openURL('competition2022.html', '_blank', {}, 'POST');
}
function formatCountView(num){
  let countView = num;
  if(countView>=10000){
    countView = (countView/10000).toFixed(1)+'萬';
  }else if(countView>=1000){
    countView = (countView/1000).toFixed(1)+'千';
  }
  countView = countView.toString().replace('.0', '');
  return `觀看次數: ${countView}次`;
}
function showPlayerView(data){
  // console.log(data);
  Object.keys(data).forEach(key=>{
    let i = key.replace('_a', '').replace('_', '');    
    let viewText = formatCountView(data[key]);
    $(`#card-carousel .card[data-value="${i}"] .view-count`).html(viewText);
  });
  updateSelectedCardView();
}
function updateSelectedCardView(){
  let i = $("#character-list .active img").attr('data-value');
  let viewText = formatCountView(playerViewData[`_a${i}_`]);
  $(`#card-selected .view-count`).html(viewText);
}
let playerViewData = { "_a01_": 2400, "_a02_": 1000, "_a03_": 60000, "_a04_": 8, "_a05_": 15, "_a06_": 41, "_a07_": 20, "_a08_": 10, "_a09_": 14, "_a10_": 13 };

$(window).on("load", function () {  
  $.getJSON('playerView.php').done(data=>{
    console.log(data);
    playerViewData = data;
    showPlayerView(data);
  });

  //Handle Window Resize 
  window.addEventListener('resize', () => {
    fitContent('resize', () => {
      $('.navbar-upperBg').css('top', -1*$('.navbar-upperBg').height()*0.75);

      if (carousel) {
        carousel.preUpdateCard();
        carousel.moveCards();
        carousel.updateArrowPosition();
      }
    });
  });

  //Onclick Event
  $(".lang-icon").on('click', event => {
    changeLang(event.target.getAttribute('name'));
  });
  $("#sidenav-menu").on('click', openSideNav);
  $("#sidenav .closebtn").on('click', closeSideNav);
  $(".file-link").on('click', event => {
    if ($('#arrow-div>img').hasClass('animate__flash')) {
      console.log('reutrn by carousel moving');
      return;
    }
    let fileName = $(event.target).closest('.file-link').attr('data-value');
    let fileType = $(event.target).closest('.file-link').attr('data-type');
    let fileIndex = '01';
    if ($('#card-selected').css('display') == 'block') {
      fileIndex = $('#card-selected').attr('data-value') || '01';
    } else {
      fileIndex = $('.card[data-x=0]').attr('data-value') || '01';
    }
    let link = 'doc/' + fileName + fileIndex + '.' + fileType;
    openURL(link, '_blank', {}, 'POST');
    
  });
  $("#card-selected .card-selected-img, #card-selected .hd-tag").on('click', event => {
    var videoID = $('#card-selected').attr('data-value') || '01';
    var videoLang = 'can'; 
    if($('.lang-icon').length!=0){
      videoLang = $('.lang-icon.active').attr('name').replace('lang_', '');
    }   
    if(videoLang=='eng') videoLang='can';
    var videoRes = $(event.target).hasClass('hd-tag') ? 'hd' : "sd";
    let videoPath = 'video/eduhk_le_animate_a' + videoID + '_';
    if(videoLang=='pth'){
      let subtitleOption = $('#card-selected .subtitleOption');
      openSubtitleOption(subtitleOption, videoPath, videoRes);
    }else{
      videoPath += videoLang + '_' + videoRes + '.mp4';
      openURL('https://crse.eduhk.mers.hk/player.php', '_blank', { 'file': videoPath }, 'GET');
    }
  });
  $('.subtitleOption .closeBtn').off().on('click', event => {
    closeSubtitleOption();
  });
  $('.subtitleOption .option').off().on('click', event => {
    let url = $(event.target).attr('data-url');
    openURL('https://crse.eduhk.mers.hk/player.php', '_blank', { 'file': url }, 'GET');
    closeSubtitleOption();
  });
  $('#character-list img').off().on('click', event => {
    closeSubtitleOption();
    $('#character-list>div').removeClass('active');
    let thisImg = $(event.target).closest('img');
    thisImg.parent().addClass('active');
    let i = thisImg.attr('data-value');
    $("#card-selected").attr('data-value', i);
    $('.card-selected-img').attr('src', './img/Mobile_char' + i + '_mo.png');
    updateSelectedCardView();
  });

  changeLang(getSession('language', 'lang_can'), () => {
    $('body').css('visibility', 'visible');
    let topPos = $('.navbar-upperBg').height() / 2 + Math.abs(parseInt($('.navbar-upperBg').css('top')));
    $('.navbar-upperBg').animate({ top: '-=' + topPos + 'px' }, 'slow', '', () => {
      $('#card-carousel').removeClass('hide');
      carousel = new CardCarousel(document.getElementById("card-carousel"));
    });
    $('nav, .desc').removeClass('hide').animateCss("slideInDown");
    $('.footbar').removeClass('hide').animateCss("slideInUp");
    $('.navbar-title').removeClass('hide').animateCss("bounceInDown");
    $('.bg-cloud-L, .bg-tree').removeClass('hide').animateCss("slideInLeft");
    $('.bg-cloud-R').removeClass('hide').animateCss("slideInRight");
    $('.bg-building-L').removeClass('hide').animateCss("fadeInRight");
    $('.bg-building-R').removeClass('hide').animateCss("fadeInLeft");

    $('.card').css({ "-webkit-filter": "brightness(50%)" });
  });

  $('#aboutThisProject').off().on('click', ()=>{
    openModal();
  }).on('mouseenter',  (event)=>{
      $(event.target).attr('src', './img/btn_project_o.png');
  }).on('mouseleave', (event)=>{
      $(event.target).attr('src', './img/btn_project.png');
  });

  $('.modalClose').off().on('click', ()=>{
    closeModal();
  }).on('mouseenter',  (event)=>{
      $(event.target).attr('src', './img/btn_close_o.png');
  }).on('mouseleave', (event)=>{
      $(event.target).attr('src', './img/btn_close.png');
  });

  $('.navbar-title-com').off().on('click', event=>{
    openCompetition2022();
  });

  $('.modalMenu>div').off().on('click', event=>{
    let tabID = $(event.target).attr('data-value');

    if(tabID=='tab-link'){
      openCompetition2022();
      return;
    }

    let currentActiveID = $('.modalMenu>div.active').attr('data-value');
    $('.modalMenu>div').removeClass('active');
    $(event.target).addClass('active');

    if(currentActiveID == tabID) return;
    if(tabID == 'tab-home'){
      closeModal();
    }else{
      openModal(tabID);
    }
  });

  /** Toggle**/
  $('.modal-character-list>img').off().on('click', event=>{
    let newTag = $(event.target);
    let newID = newTag.attr('data-value');
    let oldID = $('.modal-character-selected.active').attr('data-value');
    let oldTag = $(`.modal-character-list>img[data-value="${oldID}"]`);
    oldTag.attr('src',  `./img/btn_char_${oldID}.png`);
    newTag.attr('src',  `./img/btn_char_${newID}_o.png`);
    $(`.modal-character-selected[data-value="${oldID}"]`).removeClass('active');
    $(`.modal-character-selected[data-value="${newID}"]`).addClass('active');
  });

  if (process.env.NODE_ENV == 'development'){
    showPlayerView(playerViewData);
  }
});